import { render, staticRenderFns } from "./ReopenTaskModal.vue?vue&type=template&id=666ae76f&"
import script from "./ReopenTaskModal.vue?vue&type=script&lang=ts&"
export * from "./ReopenTaskModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports